<template><div><h1 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>Aufbereiten...</span></a></h1>
<p>Aufbereiten... — Bereinigung Zusager-Status von Personen ohne Beitragszahlung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Bereinigung der Zusagen. Z.B. am Jahresende kann es sinnvoll sein, für Zusagen, deren Beiträge auch nach wiederholter Mahnung nicht bezahlt worden sind, Austritte zu erfassen. Es werden nur Zusagen mit Zahlungsmodus ESR (unabhängig vom Kanal, also auch ESR per E-Mail) berücksichtigt, die für das eingegebene Grenzjahr keine Zahlung geleistet haben. Nicht berücksichtigt werden Zusagen, die nur einen Teilbetrag einbezahlt haben.</p>
<p>Vor dem Start dieses Programmes sollte eine Analyse den Zustand der aktuellen Zusagen überprüfen und Antworten geben auf folgende Fragen:</p>
<ul>
<li>
<p>Welche Zusagen sollen bereinigt werden?</p>
</li>
<li>
<p>Wieviele Zusagen bestehen im System, und wieviele wären von einer Bereinigung betroffen? (Zähllauf)</p>
</li>
<li>
<p>Wie lange dauert es üblicherweise, bis ein Zusager, der einen Einzahlungsschein erhalten hat, auch tatsächlich eine Zahlung leistet?</p>
</li>
<li>
<p>Sollen Zusager, welche mehrere Jahre ihre Zusage bezahlt haben, im aktuellen Jahr aber nicht mehr, aus den Zusagen entfernt werden?</p>
</li>
<li>
<p>Wie sollen Zusager behandelt werden, die nicht den vollen zugesagten Betrag einbezahlt haben?</p>
</li>
<li>
<p>Welche Kommunikationsmassnahmen wurden zur Verringerung der Nichtzahler durchgeführt und haben diese den erwarteten Erfolg gehabt?</p>
</li>
</ul>
<p>Nach Beantwortung dieser Fragen kann das Programm mit den entsprechenden Parametern versehen und die Bereinigung durchgeführt werden.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Personen → Verarbeitungsläufe → Zusagen → Jährliche Austritte</p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<dl>
<dt>LaufNr.</dt>
<dd>Fortlaufende Nummer (automatisch vom System vergeben) zur Identifikation des Jobs.</dd>
<dt>Aktion</dt>
<dd>Die Austritte können gezählt oder durgeführt werden.
<table>
<thead>
<tr>
<th>Aktion</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>nur Zählen</td>
<td>Damit wird die Anzahl der Austritte ermittelt.</td>
</tr>
<tr>
<td>Durchführen</td>
<td>Die Austritte werden durchgeführt.</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Protokoll mit Anzahl ausgetretenen Zusagen.</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Gemäss Eingabeparameter.</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Es werden Zusagen Austritte generiert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.zusjaustr.html" title="Jährliche Austritte">Jährliche Austritte</RouteLink></p>
</div></template>


